import { render, staticRenderFns } from "./PagesButton.vue?vue&type=template&id=d1ca87a2"
import script from "./PagesButton.vue?vue&type=script&lang=ts"
export * from "./PagesButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports